export default __webpack_public_path__ + "static/media/Texting.30a4e701.png";